import ProductImageSlider from './product-image-slider';

export default ProductImageSlider;